export function MoneyIcon({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Money bag with drawstring top */}
            <path
                d="M22 18L20 20C17 23 14 26 14 32V40C14 44 16 48 28 48C40 48 42 44 42 40V32C42 26 39 23 36 20L34 18M22 18L24 14L28 10L32 14L34 18M22 18H34"
                stroke="url(#paint0_linear_money)"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Dollar sign */}
            <path
                d="M28 24V40M24 28H32C33.1046 28 34 28.8954 34 30C34 31.1046 33.1046 32 32 32H24C22.8954 32 22 32.8954 22 34C22 35.1046 22.8954 36 24 36H32"
                stroke="url(#paint1_linear_money)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_money"
                    x1="28"
                    y1="10"
                    x2="28"
                    y2="48"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F093FB" />
                    <stop offset="1" stopColor="#F5576C" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_money"
                    x1="28"
                    y1="24"
                    x2="28"
                    y2="40"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F093FB" />
                    <stop offset="1" stopColor="#F5576C" />
                </linearGradient>
            </defs>
        </svg>
    );
}
